<template>
<div>
    <div>
        <vs-button color="primary" type="flat" icon-pack="feather" icon="icon-arrow-left" @click="back">Regresar</vs-button>
    </div>
    <div class="h-full md:h-screen grid grid-cols-1 md:grid-cols-3 grid-rows-6 md:grid-rows-2 gap-6 p-2">
        <div class="h-full bg-white rounded-4xl">
            <iframe v-if="meet.url" :src="meet.url" frameborder="0" class="h-full w-full rounded-4xl"></iframe>
            <div v-else class="m-auto h-full grid grid-cols-1 content-center">
                <div class="justify-self-center">
                    <vs-chip color="danger">
                        <vs-avatar icon-pack="feather" icon="icon-video" />
                        <span>Inspección virtual en proceso...</span>
                    </vs-chip>
                </div>
            </div>
        </div>
        <vx-card title="Información del Cliente" class="h-full bg-white rounded-4xl p-6 col-span-2">
            <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="font-bold">Nombres</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    {{ cliente.client_nombres }} {{ cliente.client_apellidos }}
                </div>
            </div>
            <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="font-bold">Correo</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    {{ cliente.client_email }}
                </div>
            </div>
            <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="font-bold">Teléfono</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    {{ cliente.client_phone }}
                </div>
            </div>
            <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="font-bold">Link Inspección Vehicular</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-button :href="'https://whiskysbot.mippya.com/zass/'+meet.meet_access_token+'/alone'" target="_blank" radius color="primary" type="border" size="small" icon-pack="feather" icon="icon-link"></vs-button>
                </div>
            </div>
        </vx-card>
        <vx-card class="h-full overflow-auto p-4 bg-white rounded-4xl">
            <vx-timeline :data="timelineData" />
        </vx-card>
        <vx-card title="Información del Auto" class="h-full bg-white rounded-4xl p-6">
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <span class="font-bold activity-desc">Marca</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    {{ auto.auto_marca }}
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <span class="font-bold activity-desc">Modelo</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    {{ auto.auto_modelo }}
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <span class="font-bold activity-desc">Año</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    {{ auto.auto_year }}
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <span class="font-bold activity-desc">Motor</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    {{ auto.auto_motor }}
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <span class="font-bold activity-desc">Chasis</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    {{ auto.auto_chasis }}
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <span class="font-bold activity-desc">Valor comercial</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    {{ auto.auto_valor }}
                </div>
            </div>
            <!-- <vs-divider border-style="dashed" color="success"></vs-divider> -->
        </vx-card>
        <vx-card title="Pago" class="h-full bg-white rounded-4xl p-6">
            <!-- <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <span class="font-bold activity-desc">Tasa</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">

                </div>
            </div> -->
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <span class="font-bold activity-desc">Prima Neta</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    $ {{(auto.auto_prima) - (auto.auto_prima * 0.12)}}
                </div>
            </div>
            <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/2 w-full">
                    <span class="font-bold activity-desc">Impuesto</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    $ {{auto.auto_prima * 0.12}}
                </div>
            </div>
            <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/2 w-full">
                    <span class="font-bold activity-desc">Prima Total</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    $ {{((auto.auto_prima) - (auto.auto_prima * 0.12))+(auto.auto_prima * 0.12)}}
                </div>
            </div>
        </vx-card>
        <!-- <statistics-card-line class="rounded-4xl" v-if="revenueGenerated.analyticsData" icon="DollarSignIcon" :statistic="revenueGenerated.analyticsData.revenue" statisticTitle="Pendiente de pago" :chartData="revenueGenerated.series" color="danger" type="area" /> -->
    </div>
</div>
</template>

<script>
import OT from '@opentok/client';
import PatientVideo from "../components/PatientVideo.vue";
import MedicalVideo from "../components/MedicalVideo.vue";
import getOpenTock from '../services/call_meeting'
import link from "../services/generate_link_pago";
import VxTimeline from '@/components/timeline/VxTimeline'
import VxCard from '../components/vx-card/VxCard.vue';
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import VueResponsiveText from 'vue-responsive-text'
export default {
    data() {
        return {
            orientation: '',
            sessionPatient: undefined,
            sessionMedical: undefined,
            optsPatient: {},
            optsMedical: {},
            streams: [],
            hasAudio: true,
            hasVideo: true,
            switchVideoInput: true,
            intervalTouch: undefined,
            lastTouch: undefined,
            hideControls: false,
            hasMeet: false,
            errorMeet: false,
            thanksMeet: false,
            keyOT: '',
            tokenOT: '',
            sessionOT: '',
            nameOT: '',
            alertPermission: false,
            textError: '404',
            callToAction: false,
            loadAlert: false,
            templateButton: '',
            token: '',
            meeting: {},
            counterDanger: false,
            auto: {},
            cliente: {},
            meet: {},
            revenueGenerated: {
                series: [{
                    name: 'Pendiente de pago',
                    data: [350, 275, 400, 300, 350, 300, 450]
                }],
                analyticsData: {
                    revenue: 0
                }
            },
            timelineData: [{
                color: 'warning',
                icon: 'BellIcon',
                title: 'Notificación',
                desc: 'Inspección virtual ',
                time: '15-10-2022 17:00'
            }, ],
        }
    },
    components: {
        PatientVideo,
        MedicalVideo,
        VxTimeline,
        VxCard,
        StatisticsCardLine,
        VueResponsiveText
    },
    mounted() {
        let access_token = localStorage._token_access
        this.getToken(access_token)
    },
    methods: {
        back() {
            var menu = {
                list: true,
                info: false
            }
            this.$emit('item', menu)
        },
        async getToken(token) {
            try {
                let {
                    data
                } = await getOpenTock(token)
                this.cliente = data.client
                this.meet = data
                this.auto = data.auto
                this.revenueGenerated.analyticsData.revenue = this.auto.auto_prima + this.auto.auto_prima * 0.12
                let opentok = {
                    name_doctor: ' ',
                    key: data.meet_key,
                    session: data.meet_session,
                    token: data.meet_token,
                    token_app: data.meet_access_token
                }
                // this.startMeeting(opentok);
            } catch (error) {

            }
        },
        initSession() {
            this.sessionPatient = OT.initSession(this.keyOT, this.sessionOT);
            this.sessionPatient.connect(this.tokenOT, err => {
                if (err) {
                    this.errorHandler(err);
                }
            });
            this.sessionPatient.on('streamCreated', event => {
                if (this.streams.length == 0) this.streams.push(event.stream);
                console.log(this.streams)
            });
            this.sessionPatient.on('streamDestroyed', event => {
                const idx = this.streams.indexOf(event.stream);
                if (idx > -1) {
                    this.streams.splice(idx, 1);
                }
            });
        },
        startMeeting(opentok) {
            const {
                key,
                session,
                token,
                name_doctor
            } = opentok;
            if (!key || !session || !token || !name_doctor) return;
            this.keyOT = key;
            this.sessionOT = session;
            this.tokenOT = token;
            this.nameOT = name_doctor;
            this.hasMeet = true;
            this.initSession();
        },
        errorHandler(err) {
            //if(process.env.NODE_ENV.toUpperCase() == 'DEVELOPMENT') return;
            if (this.errorMeet) return;
            this.errorMeet = true;
            this.hasMeet = false;
            this.callToAction = true;
            const {
                name
            } = err;
            switch (name) {
                case 'OT_USER_MEDIA_ACCESS_DENIED':
                    this.textError = this.$t('common_label_error_permmission');
                    this.templateButton = 'permission_denied';
                    break;
                case 'OT_AUTHENTICATION_ERROR':
                    this.textError = this.$t('modal_videocall_label_expired');
                    this.templateButton = 'session_expired';
                    break;
                default:
                    break;
            }
            return;
        },
        setHeightPage() {
            document.documentElement.style.setProperty('--heightPage', `${window.innerHeight}px`);
            document.documentElement.style.setProperty('--widthPage', `${window.innerWidth}px`);
        },
        guardar() {
            this.$router.push("home");
        },
        async generate() {
            try {
                let prima = 1000
                let impuesto = 100;
                let subtot = (prima + impuesto) * 100
                let iva = ((prima + impuesto) * 0.12) * 100
                let total = subtot + iva;
                let data = {
                    pg_client: this.cliente.client_id,
                    pg_iva: iva,
                    pg_total: total
                }
                let resp = await link(data);
                console.log(resp)
            } catch (error) {

            }
        }
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>
